export const dateRangePagination = 'date-range-pagination';
